const LOGIN_URL = "/v1/auth/login";
const LIST_URL = "/v1/user/list";
const SINGLE_USER_URL = "/v1/user/single";
const ROLE_GROUP_LIST_URL = "/v1/user/role-group/list";
const ROLE_LIST_URL = "/v1/user/role/list";
const ADD_USER_URL = "/v1/user/add";
const UPDATE_USER_URL = "/v1/user/update";
const DELETE_USER_URL = "/v1/user/delete";
const CHANGE_USER_PASSWORD_URL = "/v1/auth/change-password";
const REFERANCE_LIST_URL = "/v1/user/reference-list";
const REFERANCE_ADD_URL = "/v1/user/reference-add";
const REFERANCE_SINGLE_URL = "/v1/user/reference-single";
const REFERANCE_APPROVE_URL = "/v1/user/reference-approve";
const REFERANCE_DENY_URL = "/v1/user/reference-denied";
const REFERANCE_UPDATE_URL = "/v1/user/reference-update";
const UPDATE_USER_BRANCH_WAREHOUSE = "/v1/user/update-branch-warehouse";
const FORGOT_PASSWORD_URL = "/v1/auth/forgot-password";
const UPDATE_ERP_CODE = "/v1/user/update-erpCode";

const USER_API_URL_LIST = {
    LOGIN_URL,
    LIST_URL,
    SINGLE_USER_URL,
    ROLE_GROUP_LIST_URL,
    ROLE_LIST_URL,
    ADD_USER_URL,
    UPDATE_USER_URL,
    DELETE_USER_URL,
    CHANGE_USER_PASSWORD_URL,
    REFERANCE_LIST_URL,
    REFERANCE_ADD_URL,
    REFERANCE_SINGLE_URL,
    REFERANCE_APPROVE_URL,
    REFERANCE_DENY_URL,
    REFERANCE_UPDATE_URL,
    UPDATE_USER_BRANCH_WAREHOUSE,
    FORGOT_PASSWORD_URL,
    UPDATE_ERP_CODE
}

export { USER_API_URL_LIST };



